import { render, staticRenderFns } from "./RepeatUnsupportedWarning.vue?vue&type=template&id=56abbbb8&"
import script from "./RepeatUnsupportedWarning.vue?vue&type=script&lang=js&"
export * from "./RepeatUnsupportedWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56abbbb8')) {
      api.createRecord('56abbbb8', component.options)
    } else {
      api.reload('56abbbb8', component.options)
    }
    module.hot.accept("./RepeatUnsupportedWarning.vue?vue&type=template&id=56abbbb8&", function () {
      api.rerender('56abbbb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editor/Repeat/RepeatUnsupportedWarning.vue"
export default component.exports